export const EditIcon = () => {
  return (
    <svg
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_edit)">
        <path
          d="M4.6123 16.89L6.94173 17.32L15.4059 9.07L13.0765 6.68L4.6123 16.89ZM19.3085 7L17.7294 5.46C17.5058 5.24 17.201 5.12 16.886 5.12C16.571 5.12 16.2662 5.24 16.0426 5.46L14.6688 6.8L17.0084 9.19L18.3822 7.85C18.6058 7.63 18.7181 7.33 18.7181 7.02C18.7181 6.71 18.6058 6.41 18.3822 6.19L19.3085 7ZM3.35088 19C3.22923 19 3.1177 18.95 3.02646 18.86C2.93522 18.77 2.88453 18.66 2.88453 18.54V16.08C2.88453 15.99 2.91595 15.9 2.96866 15.83L13.4292 5.07C13.4799 5.02 13.5407 4.98 13.6117 4.95C13.6827 4.92 13.7537 4.9 13.8349 4.9C13.9161 4.9 13.9871 4.92 14.0581 4.95C14.1291 4.98 14.1899 5.02 14.2406 5.07L16.57 7.46C16.6217 7.51 16.6633 7.57 16.6947 7.64C16.7261 7.71 16.7474 7.78 16.7474 7.86C16.7474 7.94 16.7261 8.01 16.6947 8.08C16.6633 8.15 16.6217 8.21 16.57 8.26L6.10947 19.02C6.0588 19.07 5.99797 19.11 5.927 19.14C5.85602 19.17 5.78505 19.19 5.70383 19.19H3.35088V19Z"
          fill="#152c70"
        />
      </g>
      <defs>
        <clipPath id="clip0_edit">
          <rect
            width="24.3318"
            height="24"
            fill="white"
            transform="translate(0.856934)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};